<template>
  <div>
    <h2>{{$t('TEXT_TRANSFER')}} {{wallet.name}} ({{(wallet.displaySymbol)}})</h2>
    <form class="popup-inner" @submit.prevent="doTransfer" :class="{ 'loading': isProcessing }">
      <div class="item">
        <label>{{ $t('TEXT_AMOUNT') }}</label>
        <input
          type="text"
          autocomplete="off"
          required
          v-model="form.amount"
          :placeholder="`0.00 ${wallet.displaySymbol}`"
        >
        <span class="field-description error-text" v-if="form.amount && !isValidAmount">
          {{ $t('TEXT_MIN_TRANSFER') }} {{minCurrencyTransfer}}&nbsp;{{ wallet.displaySymbol }},
          {{ $t('TEXT_MAX_TRANSFER') }} {{maxCurrencyTransfer}}&nbsp;{{ wallet.displaySymbol }}
        </span>
        <span class="field-description error-text" v-if="form.amount && isValidAmount && isInValidAmountPrecision">
          {{ $t('MSG_MAXIMUM_AMOUNT_PRECISION_IS', { amountPrecision: this.wallet.numberDecimal}) }}
        </span>
        <span class="field-description error-text" v-else-if="isNaNAmount">
          {{ $t('MSG_AMOUNT_MUST_BE_A_NUMBER') }}
        </span>
        <p class="item-description">
          <a :class="{'disabled': wallet.balanceIeo === 0}" @click="swapMax">
            <span>{{ $t('BTN_MAX') }}</span>
          </a>
        </p>
      </div>
      <div class="item item-balance">{{ $t('TEXT_BALANCE') }}: <span>{{ wallet.beautyBalance }}</span></div>
      <div class="item item-fee">
        <div class="flex-box">
          <div style="flex-basis: 140px">{{ $t('TEXT_TRANSFER_FEE') }}:</div>
          <div class="flex-grow dark-color">
            <span>{{ feeTransfer }}</span>&nbsp;
            <span>{{ wallet.displaySymbol }}</span>
          </div>
        </div>
        <div class="flex-box">
          <div style="flex-basis: 140px">{{$t('TEXT_YOU_WILL_GET')}}: </div>
          <div class="flex-grow buy-color">
            <span>{{ estimateReceiveAmount }}</span>&nbsp;
            <span>{{ wallet.displaySymbol }}</span>
          </div>
        </div>
      </div>
      <div class="item item-submit">
        <a class="btn btn-submit" :class="{ 'disabled': !isValidated }" @click="doTransfer">{{ $t('BTN_TRANSFER') }}</a>
      </div>
    </form>
  </div>
</template>

<script>
import UtilService from '@/utils/UtilService'
export default {
  props: {
    wallet: {}
  },
  data () {
    return {
      form: {
        amount: null,
        toAddress: ''
      },
      isProcessing: false
    }
  },
  computed: {
    pagination () {
      return this.$store.getters.pagination
    },
    user () {
      return this.$store.getters.user
    },
    wallets () {
      return this.$store.getters.wallets
    },
    isValidAmount () {
      let result = null
      if (this.form.amount && UtilService.isLargerOrEqual(this.form.amount, this.minCurrencyTransfer) &&
        UtilService.isLessOrEqual(this.form.amount, this.maxCurrencyTransfer)) {
        result = true
      } else result = false
      return result
    },
    feeTransfer () {
      return 0
    },
    maxCurrencyTransfer () {
      let result = 0
      this.wallet.balanceIeo > this.wallet.transferMaxAmount ? result = this.wallet.transferMaxAmount : result = this.wallet.balanceIeo
      return result
    },
    estimateReceiveAmount () {
      if (!this.form.amount) return 0
      return UtilService.calculateEstimateAmount(this.form.amount, this.feeTransfer, this.wallet)
    },
    configs () {
      return this.$store.getters.configs
    },
    minTransfer () {
      return this.wallet.transferMinAmount || 0
    },
    minCurrencyTransfer () {
      return this.minTransfer || 0
    },
    isValidated () {
      return this.form.amount && this.isValidAmount && !this.isInValidAmountPrecision && !this.isNaNAmount &&
        Number(this.form.amount) > 0
    },
    isAddressValid () {
      return UtilService.isValidAddress(this.form.toAddress, this.wallet)
    },
    isInValidAmountPrecision () {
      return this.form.amount && !UtilService.checkValidAmountDecimals(this.form.amount, this.wallet.numberDecimal)
    },
    isNaNAmount () {
      return !this.isInValidAmount && this.form.amount && isNaN(this.form.amount)
    }
  },
  methods: {
    swapMax () {
      if (this.wallet.balanceIeo > 0) {
        this.form.amount = this.maxCurrencyTransfer
      }
    },
    swapMin () {
      if (this.wallet.balanceIeo > 0) {
        this.form.amount = this.minCurrencyTransfer
      }
    },
    doTransfer () {
      if (!this.isValidated) return
      const data = {}
      data.currency = this.wallet.symbol
      data.amount = this.form.amount
      data.type = 'IEO_MAIN'
      this.isProcessing = true
      this.$store.dispatch('transfer', data).then(status => {
        setTimeout(() => {
          this.isProcessing = false
          if (status) {
            this.$store.dispatch('toggleAmountForm')
            this.$store.dispatch('getTransHistory', this.pagination.currentPage || 1)
          }
        }, 500)
      })
    }
  }
}
</script>
